import React from 'react'
import Grid from '@material-ui/core/Grid'
import Typography from '@material-ui/core/Typography'
import { withStyles } from '@material-ui/core/styles'
import Img from 'gatsby-image'

import styles from './styles'

const Story = withStyles(styles)(props => {
  const { classes, section, key } = props

  return (
    <div style={{width: '100%'}} key={key}>
      <div className={classes.contents}>
        <div className={classes.centred}>
          <div className={classes.section} style={{width: '100%'}}>
            <Grid container spacing={40}>
              <Grid item xs={12}>
                {section.image && section.image.src.length>0 && (
                  <img
                    src={section.image.src}
                    alt={section.image.alt}
                    className={classes.sectionImage}
                  />
                )}
              </Grid>
            </Grid>
          </div>
        </div>
      </div>
      {section.contents.map((content, index) => {
        return <StoryContent key={key} content={content} classes={classes} />
      })}
    </div>
  )
})

const StoryContent = ({ content, classes, key }) => {
  return (
    <div style={{width: '100%'}} key={key}>
      {content.image && <Teaser image={content.image} />}
      <div className={classes.contents}>
        <div className={classes.centred}>
          <div className={classes.section} style={{width: '100%'}}>
            <Grid container spacing={40}>
              <Grid item xs={12}>
                <Typography gutterBottom variant="title">
                  {content.title.text}
                </Typography>
                <Typography gutterBottom variant="subheading">
                  {content.subtitle.text}
                </Typography>
                <div
                  dangerouslySetInnerHTML={{
                    __html: content.text && content.text.html,
                  }}
                  className={classes.text}
                />
              </Grid>
            </Grid>
          </div>
        </div>
      </div>
    </div>
  )
}

const Teaser = withStyles(styles)(props => {

  const { classes, image } = props

  return (
    <div className={classes.teaser} style={{width: '100%'}}>
      <Grid container spacing={0}>
        <Grid item xs={12}>
          <div
            style={{
              background: `url(${image.src})`,
              backgroundPosition: 'center',
              backgroundSize: 'cover',
              height: '50vh',
            }}
          />
        </Grid>
      </Grid>
    </div>
  )
})

export default withStyles(styles)(Story)



// WEBPACK FOOTER //
// ./src/components/story/index.js